import createContentReducer from '../utils/createContentReducer';
import { FAQS } from '../constants/apiTypes';
import decodeContent from '../normalizers/decodeContent';

const decodeFAQs = decodeContent({
  itemsKey: 'questions',
  nameKey: 'name',
  titleKey: 'question',
  contentKey: 'answer'
});

const faqsReducer = createContentReducer(FAQS, {
  normalizeData: decodeFAQs
});

export default faqsReducer;
